<template>
    <div class="wrap-index">
        <!--最新资讯banner-->
        <div class="infomation">
            <h3 class="common-title">
                新闻资讯
            </h3>
            <div class="banner">
                <div class="swiper-wrapper">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide v-for="(item,i) in banner" :key="i">
                            <router-link :to="'/hotcontent/'+item.id">
                                <div class="cover">
                                    <img :src="item.picture">
                                    <p class="title">{{item.title}}</p>
                                </div>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-pagination"  slot="pagination"></div>
                    </swiper>
                </div>
            </div>
        </div>
        <!--最热新闻-->
        <div class="news">
            <h3 class="common-title">
                热点新闻
                <router-link to="/hot" class="more">查看更多>></router-link>
            </h3>
            <div class="news-list">
                <div class="news-item" v-for="(item,i) in newNews" :key="i">
                    <router-link :to="'/hotcontent/'+item.id">
                        <h3 class="title">{{item.title}}</h3>
                        <div class="img">
                            <div class="img-item" v-for="(img,j) in item.images" :key="j">
                                <img :src="img"/>
                            </div>

                        </div>
                        <p class="time">{{item.create_time}}</p>
                    </router-link>
                </div>
            </div>
        </div>
        <!--往期资讯-->
        <div class="old-news">
            <h3 class="common-title">
                最新资讯
                <router-link to="/hot" class="more">查看更多>></router-link>
            </h3>
            <div class="old-news-item" v-for="(item,i) in pastNews" :key="i">
                <!--文章-->
                <ul class="news-list">
                    <li v-for="(articleItem,i) in item.newNewList" :key="i">
                        <router-link :to="'/hotcontent/'+articleItem.id">
                            <div class="cover">
                                <img :src="articleItem.picture">
                            </div>
                            <div class="news-info">
                                <p class="name">{{articleItem.title}}</p>
                                <p class="desc">{{articleItem.article}}</p>
                                <p class="author">
                                    {{articleItem.create_time}}
                                </p>
                            </div>
                        </router-link>
                    </li>
                </ul>
                <!--视频-->
                <div class="video">
                    <router-link  :to="'/videocontent/'+item.video.id">
                        <h3 class="title">{{item.video.title}}</h3>
                        <video class="video-js" :id="'myVideo'+item.video.id" controls :poster="item.video.picture" x5-playsinline="true" webkit-playsinline="true" playsinline="true">
                            <source :src="item.video.video" type="video/mp4">
                        </video>
                        <p class="time">{{item.video.create_time}}</p>
                    </router-link>
                </div>
            </div>
        </div>
        <ul class="icon-list">
            <li>
                <div class="img">
                    <img src="../assets/icon-Browser.png"/>
                </div>
                <h3 class="name">娱乐营销</h3>
                <p class="desc">顶级策划团队，雄厚媒体资源，借力打力，以巧取胜</p>
            </li>
            <li>
                <div class="img">
                    <img src="../assets/icon-Camera.png"/>
                </div>
                <h3 class="name">
                    艺人推广
                </h3>
                <p class="desc">
                    实时动态监控，把牢舆情方向，热点策源 ，家喻户晓。
                </p>
            </li>
            <li>
                <div class="img">
                    <img src="../assets/icon-iPhone.png"/>
                </div>
                <h3 class="name">
                    艺人经纪
                </h3>
                <p class="desc">
                    深挖艺人亮点，定制成长方案，量身打造，保驾护航。
                </p>
            </li>
            <li>
                <div class="img">
                    <img src="../assets/icon-vip.png"/>
                </div>
                <h3 class="name">
                    影视宣传
                </h3>
                <p class="desc">
                    全媒介战略合作大矩阵个性投送，分众传媒病毒传播。
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
    require('swiper/dist/css/swiper.css');
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        components: {
            swiper,
            swiperSlide
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        metaInfo() {
            return {
                title: this.webtitle || '',
                meta: [{
                    name: 'keywords',
                    content: this.webkeywords|| ''
                }, {
                    name: 'description',
                    content: this.webdescription|| ''
                }]
            }
        },
        data(){
            return{
                swiperOption: {
                    loop:true,
                    speed:500,   //切换速度
                    mousewheelControl: false,// 禁止鼠标滚轮切换
                    initialSlide :1,
                    lazy: {
                        loadPrevNext: true,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    autoplay: {
                        delay:2000,
                        stopOnLastSlide: false, // 切换到最后一个时不停止
                        disableOnInteraction: false, //用户操作swiper之后 不停止autoplay
                    },
                    watchSlidesProgress:true,
                    centeredSlides: true, //设定为true时，活动块会居中，而不是默认状态下的居左。
                    spaceBetween:20,
                    slidesPerView: 1.1,
                    loopedSlides :2,
                    observer: true,
                    observeParents: true
                },
                banner:[],
                newNews:[],
                pastNews:[],
                webdescription:'',
                webkeywords:'',
                webtitle:''
            }
        },
        mounted() {
            this.initVideo();
        },
        methods:{
            //seo接口
            getSeo() {
                let seoApi = 'https://api.yopoo.cn/api/v1/getweb'
                this.$http.get(seoApi)
                    .then((res) => {
                        let result = res.data
                        this.webdescription = result.webdescription
                        this.webkeywords = result.webkeywords
                        this.webtitle = result.webtitle
                    }, err => {
                        console.log(err)
                    })

            },
            initVideo() {
                this.pastNews.map((item,i)=>{
                    let id = item.video.id || 0
                    let myPlayer = this.$video('myVideo'+id, {
                        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                        controls: true,
                        poster:this.video.picture || ''
                    });
                })
            }
        },
        created(){
            var Api = 'https://api.yopoo.cn/api/v1/collection';
            this.$http.get(Api).then( res => {
                    var result = res.data.data || {};
                    this.banner = result.newInfo;
                    this.newNews = result.newNews;
                    this.pastNews = result.inPastNews;
                },
                err => {
                    console.log(err)
                }
            )
            this.getSeo()
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-index{
        .common-title{
            height: .84rem;
            line-height: .84rem;
            padding: 0 .4rem;
            font-size: .32rem;
            color: #333;
            .more{
                float: right;
                font-size: .26rem;
                font-weight: normal;
            }
        }
        .news{
            margin-top: .24rem;
            .news-list{
                padding: 0 .4rem;
                .news-item{
                    border-bottom: 1px solid #ccc;
                    margin-bottom: .24rem;
                    .title{
                        font-size: .32rem;
                        color: #333;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .img{
                        display: flex;
                        margin-top: 10px;
                        .img-item{
                            flex: 1;
                            height: 1.6rem;
                            display: inline-block;
                            margin-left: .2rem;
                            overflow: hidden;
                            &:first-child{
                                margin-left: 0;
                            }
                            img{
                                width: 100%;
                            }
                        }

                    }
                    .time{
                        padding: .1rem 0 .24rem 0;
                        font-size: .22rem;
                        color: #989898;
                    }
                }
            }
        }
        .old-news{
            .old-news-item{
                padding: 0 .4rem;
                .news-list{
                    li{
                        border-bottom: 1px solid #ccc;
                        &:first-child{
                            a{
                                padding-top: 0;
                            }
                        }
                        a{
                            padding: .2rem 0;
                            box-sizing: border-box;
                            display: flex;
                            cursor: pointer;
                            .cover{
                                width: 2.1rem;
                                background: #000;
                                height: 1.6rem;
                              object-fit: fill;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .news-info{
                                width: 4.7rem;
                                padding: 0 .2rem;
                                color: #333;
                                .name{
                                    font-size: 0.3rem;
                                    line-height: 0.36rem;
                                    font-weight: bold;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    height: .36rem;
                                }
                                .desc{
                                    font-size: .28rem;
                                    line-height: .34rem;
                                    margin-top: .1rem;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    height: .68rem;
                                }
                                .author{
                                    font-size: .24rem;
                                    color: #999;
                                    height: .34rem;
                                    line-height: .34rem;
                                }
                            }
                        }

                        &:hover{
                            a{
                                background: #f8f8f8;
                                .news-info{
                                    color: #7E0007;
                                }
                            }

                        }
                    }
                }
                .video{
                    border-bottom: 1px solid #ccc;
                    margin-bottom: .2rem;
                    .title{
                        font-size: .32rem;
                        color: #333;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        padding: .24rem 0 .1rem 0;
                    }
                    .time{
                        height: .54rem;
                        line-height: .54rem;
                        color: #9a9a9a;
                        font-size: .28rem;
                    }
                    .video-js{
                        width: 100%;
                        height: 3.7rem;
                        object-fit: fill;
                        .vjs-big-play-button{
                            top: 50%;
                            left: 50%;
                            padding: 0;
                            margin-top: -.4rem;
                            margin-left: -.4rem;
                            width: .8rem;
                            height: .8rem;
                            line-height: .8rem;
                            border-radius: 100%;
                            outline: none;
                            background: rgba(255,255,255,.3);
                            border: 0;
                        }
                        .vjs-poster{
                            background-size: 100%;
                        }
                    }
                }

            }
        }

        .icon-list{
            display: flex;
            text-align: center;
            padding: 0 .4rem;
            li{
                .img{
                    width: 1rem;
                    height: 1rem;
                    margin: 0 auto;
                    img{
                        width: 100%;
                        height: 100%;
                        vertical-align: top;
                    }
                }
                .name{
                    font-size: .18rem;
                    height: .3rem;
                    line-height: .3rem;
                    color: #131313;
                }
                .desc{
                    color: #676767;
                    font-size: .12rem;
                    line-height: .16rem;
                }
            }

        }
        .banner{
            height: 3.7rem;
            .swiper-slide{
                height: 3.4rem;
                .cover{
                    position: relative;
                    height: 3.4rem;
                    .title{
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        background: rgba(0,0,0,.5);
                        color: #fff;
                        font-size: .3rem;
                        height: .48rem;
                        line-height: .48rem;
                        padding-left: .2rem;
                        width: 100%;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .swiper-pagination{
                bottom:-30px !important;
                .swiper-pagination-bullet{
                    width: .12rem;
                    height: .12rem;
                }
                .swiper-pagination-bullet-active{
                    background: #666;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue